<div class="main-app container-md view-content">
  <router-outlet></router-outlet>
  <div class="d-flex justify-content-between align-items-center footer">
  <div>
      2025 Dadyin.All rights reserved.
  </div>
  <div> <img width="20px" src="../assets/img/icons/whatsapp.svg"> Whatsapp us | Facing issues? <a href="https://api.whatsapp.com/send/?phone=12016858131&text&type=phone_number&text=Hi,I have a query related to dadyin platform." class="text-primary"> Get help </a>
  </div>
</div>
</div>

<app-print-templates></app-print-templates>
